/**
 * Controles de filtro da aba /auditoria — extraídos de index.tsx (limite de 200
 * linhas por arquivo, frontend.md). Label associado ao controle via htmlFor/id.
 */
import { type ReactNode } from 'react';

export const INPUT_CLS =
  'h-[36px] w-full rounded-md border border-jf-border bg-jf-surface px-3 text-sm text-white outline-none focus:border-jf-yellow';

export function Field({
  label,
  htmlFor,
  children,
}: {
  label: string;
  htmlFor: string;
  children: ReactNode;
}) {
  return (
    <div>
      <label htmlFor={htmlFor} className="block text-[10px] uppercase tracking-wide text-jf-dim mb-1">
        {label}
      </label>
      {children}
    </div>
  );
}

export function Select({
  id,
  value,
  onChange,
  children,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
  children: ReactNode;
}) {
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={INPUT_CLS}
      autoComplete="off"
    >
      {children}
    </select>
  );
}
